import { translate as t } from '../../i18n/translations';

export default (message) => window.BvFrontend.ModalHelper.showDangerMessage({
  title: t('javascript.error_page.error'),
  message,
  iconClosable: true,
  icon: false,
});
